import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimberService } from '@logging/timber.service';

@Component({
	selector: 'eup-generic-slider',
	templateUrl: './slider.component.html',
	styleUrls: ['./slider.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SliderComponent),
			multi: true
		}
	]
})
export class SliderComponent implements ControlValueAccessor, AfterViewInit {
	@Input() label: string = '';
	@Input() sliderMin: string = '';
	@Input() sliderMax: string = '';
	@Input() min: number = 0;
	@Input() max: number = 100;
	@Input() step: number = 1;
	@Input() id: string = '';
	@Input() locationParentObject: string = '';
	@Input() value: number = 0;

	@ViewChild('rangeInput') rangeInput: ElementRef<HTMLInputElement>;

	@Output() valueCommitted = new EventEmitter<number>();

	private onChange: (value: number) => void = () => {};
	private onTouched: () => void = () => {};

	constructor(private timberService: TimberService) {}

	ngAfterViewInit(): void {
		this.rangeInput.nativeElement.value = this.value.toString();
	}

	get progress(): string {
		const range = this.max - this.min;
		if (range === 0) return '0%';
		return ((this.value - this.min) / range * 100) + '%';
	}

	onInputChange(event: Event): void {
		const val = Number((event.target as HTMLInputElement).value);
		this.value = val;
		this.onChange(val);
		this.onTouched();
	}

	onCommit(event: Event): void {
		const val = Number((event.target as HTMLInputElement).value);
		this.valueCommitted.emit(val);
	}

	writeValue(value: number): void {
		if (value !== null && value !== undefined) {
			this.value = value;
			if (this.rangeInput) {
				this.rangeInput.nativeElement.value = value.toString();
			}
		}
	}

	registerOnChange(fn: (value: number) => void): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
}
